export { AnimationStyles, AnimationVariables } from '@fluentui/theme/lib/motion/AnimationStyles';
